import { Injectable, Inject, Output, EventEmitter } from '@angular/core';
import { Http, Headers, RequestOptionsArgs, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { AlertService } from './index';
import { ApiService } from '../services/api.service';
import { REST_API_REQUEST_CALL_URL } from '../utils/index';
import { UserModel } from '../services/index';



declare var moment:any;
 
@Injectable()
export class VesselService {

    oceanLineList:Array<OceanLineModel> = new Array();
    terminalList:Array<TerminalModel> = new Array();
    @Output() oceanLineListEe: EventEmitter<Array<OceanLineModel>> = new EventEmitter();
    @Output() terminalListEe: EventEmitter<Array<TerminalModel>> = new EventEmitter();

    constructor(private apiService:ApiService) { 

    }

    getOceanLineList(){
        if(!this.oceanLineList || this.oceanLineList.length < 1){
            this.initOceanLineList();
        }else{
            this.oceanLineListEe.emit(this.oceanLineList);   
        }
    }

    initOceanLineList(){
        this.apiService.get('oceanline').subscribe(
            res => {
                if(res.result){
                    this.oceanLineList = res.data;
                    this.oceanLineListEe.emit(res.data);
                }
            }
        );
    }

    getTerminalList(){
        if(!this.terminalList || this.terminalList.length < 1){
            this.initTerminalList();
        }else{
            this.terminalListEe.emit(this.terminalList);
        }
    }

    initTerminalList(){
        this.apiService.get('terminal').subscribe(
            res => {
                if(res.result){
                    this.terminalList = res.data;
                    this.terminalListEe.emit(res.data);
                }
            }
        );
    }
    
    getVesselList(): Observable<any>{
        return this.apiService.get('admin/vessels');
    }

    getVessel(vesselId:number): Observable<any>{
        return this.apiService.get('admin/vessels/' + vesselId);
    }

    getVesselMap(vesselMapId:number): Observable<any>{
        return this.apiService.get('admin/vessels/maps/' + vesselMapId);
    }

    getVesselMapListByVesselId(vesselId:number): Observable<any>{
        return this.apiService.get('admin/vessels/' + vesselId + '/maps');
    }

    postVessel(data:any){
        return this.apiService.post('admin/vessels', data);
    }
    
    patchVessel(data:any){
        return this.apiService.patchReqDataType('admin/vessels', data);
    }

    postVesselMap(data:any){
        let body = {
            vesselMapList: data
        };
        return this.apiService.post('admin/vessels/maps', body);
    }
    
    patchVesselMap(data:any){
        let body = {
            vesselMapList: data
        };
        return this.apiService.patchReqDataType('admin/vessels/maps', body);
    }

    getVesselMapList(): Observable<any>{
        return this.apiService.get('admin/vessels/maps');
    }

    getVesselMapListByStatus(statusCd:number): Observable<any>{
        return this.apiService.get('admin/vessels/maps/status/'+ statusCd);
    }
}

export class VesselModel {
    vslId:number;
    vslNm:string;
    builtYy:string;
    cntryCd:string;
    cntryNm:string;
    depth:number;
    length:number;
    width:number;
    dwt:number;
    imoNo:string;
    mmsi:string;
    callSign:string;
    operCd:string;
    operNm:string;
    plug:number;
    speed:number;
    teu:number;
    waterLine:number;
    stusCd:number;
    modifyUser:UserModel;
    modifyDate:string;
    grt:number;
    teu14Tons:number;
    match:number;
    isChecked:boolean;
}

export class VesselMapModel {
    vesselMapId:number;
	operCd:string;
    operTpCd:number;
    operTpNm:string;
	operVslNm:string;
	vessel:VesselModel;
    vesselMapStatusCd:number;
    vesselMapStatusNm:string;
	modifyUser:UserModel ;
	modifyDate:string;
    reqSystemCd:number;
    reqSystemNm:string;
	reqDtm:string;
    remark:string;
    isChecked:boolean;
}

export class OceanLineModel {
    lineCd:string;
	lineNm:string;
	lineNm2:string;
	lineNmKr:string;
	alliance:string;
	cntryCd:string;
}

export class TerminalModel {
    terminalCd:string
	terminalNm:string
	terminalNmShrt:string
	port:any;
}


export class Oper {
    operCd:string;
    operNm:string;
    operTpCd:number;
    operTpNm:string;
}


// WEBPACK FOOTER //
// ./src/app/services/vessel.service.ts